import { SxProps, Theme } from '@mui/material';

export const removeInputPadding: SxProps<Theme> = { px: 1, py: 0.5 };
